import React from 'react';
import className from 'classnames';

class InputPassword extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
    name: 'password',
    placeholder: 'Password',
  };

  state = {
    isActive: false,
    required: false,
  };

  render = () => {
    return (
      <div className='Input Input--with-icon'>
        <input
          type={this.state.isActive ? 'text' : 'password'}
          className='Input__input'
          placeholder={this.props.placeholder}
          name={this.props.name}
          required={this.props.required}
        />

        <a
          title='Click to show password'
          className={className('Input__a', {
            'Input__a--eye': true,
            'Input__a--eye--active': this.state.isActive,
          })}
          onClick={() => {
            this.setState((prevState) => ({
              isActive: !prevState.isActive,
            }))
          }}
        />
      </div>
    );
  }
}

export default InputPassword;
